import { Card, Muted, RadialMeter, Stack, color, space, status } from '@biopeak/ui';
import { formatarData, useSerbioColetas } from '../lib/serbio.ts';

/**
 * O CVRC na visão geral — resumo executivo do Painel SERBIO.
 *
 * Só o número e o quanto dele é confiável. Os 15 índices, os compostos e os
 * gatilhos ficam na aba SERBIO; aqui a pergunta é apenas "preciso abrir
 * aquilo agora?". Some quando não há coleta com índice calculável, como o
 * resto dos cards desta grade.
 */
export function SerbioScoreCard({ patientId }: { patientId: string }) {
  const coletas = useSerbioColetas(patientId);
  const coleta = coletas.data?.[0];
  if (!coleta) return null;

  const cvrc = coleta.cvrc ?? 0;
  const avaliados = coleta.cvrc_criterios_avaliados ?? 0;
  const tom = cvrc >= 6 ? status.red : cvrc >= 3 ? status.yellow : status.green;

  return (
    <Card>
      <Stack gap={space.sm}>
        <span style={{ fontSize: '13px', color: color.textSecondary }}>
          SERBIO-CVRC
        </span>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <RadialMeter
            value={cvrc}
            min={0}
            max={10}
            size={140}
            fillColor={tom.fg}
            valueLabel={String(cvrc)}
            unitLabel="de 10"
            startEndpointLabel="0"
            endEndpointLabel="10"
          />
        </div>

        <span style={{ fontSize: '14px', fontWeight: 600, color: tom.fg }}>
          {cvrc >= 6 ? 'Risco alto' : cvrc >= 3 ? 'Risco intermediário' : 'Risco baixo'}
        </span>

        <Muted style={{ fontSize: '12px' }}>
          {avaliados < 8
            ? `${avaliados} de 8 critérios dosados na coleta de ${formatarData(coleta.data_coleta)} — o restante conta como zero por falta de exame.`
            : `8 de 8 critérios dosados na coleta de ${formatarData(coleta.data_coleta)}.`}
        </Muted>
      </Stack>
    </Card>
  );
}
